import React from "react";

function IconPhotoAlt(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 24"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.933 2.7a2.1 2.1 0 0 0-2.1 2.1v14.4c0 1.16.94 2.1 2.1 2.1h16.8a2.1 2.1 0 0 0 2.1-2.1V4.8a2.1 2.1 0 0 0-2.1-2.1h-16.8Zm-.3 2.1a.3.3 0 0 1 .3-.3h16.8a.3.3 0 0 1 .3.3v8.157l-3.314-2.84a.9.9 0 0 0-1.244.069l-8.4 9a.897.897 0 0 0-.19.314H3.933a.3.3 0 0 1-.3-.3V4.8Zm17.115 10.283c.086.075.183.13.285.166V19.2a.3.3 0 0 1-.3.3H10.244l6.959-7.455 3.545 3.038ZM8.133 10.8a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconPhotoAlt;
